export default "__VITE_ASSET__Cp5asHND__"